<template>
  <div>
    <div>
      <b-jumbotron>
        <template #header>Cabaco</template>

        <template #lead>
          This is a simple hero unit, a simple jumbotron-style component for calling extra attention to
          featured content or information.
        </template>

        <hr class="my-4">

        <p>
          It uses utility classes for typography and spacing to space content out within the larger
          container.
        </p>

        <b-button
          variant="primary"
          href="#"
        >Do Something</b-button>
        <b-button
          variant="success"
          href="#"
        >Do Something Else</b-button>
      </b-jumbotron>
    </div>
    <shopping-list></shopping-list>
  </div>
</template>

<script>
import ShoppingList from "@/components/ShoppingList";

export default {
  components: { ShoppingList },
  name: "Cabaco",
  data() {
    return {
      msg: "Welcome to Cabaco"
    };
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Cabaco.vue